import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=808ae2b6"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"
import style0 from "./Review.vue?vue&type=style&index=0&id=808ae2b6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('808ae2b6')) {
      api.createRecord('808ae2b6', component.options)
    } else {
      api.reload('808ae2b6', component.options)
    }
    module.hot.accept("./Review.vue?vue&type=template&id=808ae2b6", function () {
      api.rerender('808ae2b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/Review/Review.vue"
export default component.exports